import { AfterViewInit, Component, OnInit } from '@angular/core';
import * as _ from 'underscore';
import { PATHS } from '../../../../analytics/constants/analytics.constants';

import { PrintableReportComponent } from '../../../../widget-library/widgets/printable-report/printable-report.component';

@Component({
	selector: 'app-printable-report-item-r1',
	templateUrl: './printable-report-item-r1.component.html',
	styleUrls: ['./printable-report-item-r1.component.css']
})
export class PrintableReportItemComponent extends PrintableReportComponent implements OnInit, AfterViewInit {
	public printableButtonItems;
	public currentProduct;
	public isActive: boolean = false;
	public isR103: boolean;
	public overviewPrintableReport: boolean = false;

	ngOnInit(): void {
		this.isR103 =
			this.analyticsDataModel.config.directoryName.toLowerCase() === 'default-r103' ||
			this.analyticsDataModel.config.directoryName.toLowerCase() === 'entravision-r103'
				? true
				: false;
		this.overviewPrintableReport = [
			'default-r702',
			'default-r701',
			'default-r7',
			'default-r103',
			'entravision-r103'
		].includes(this.analyticsDataModel.config.directoryName.toLowerCase());
		const navWidgets = JSON.parse(JSON.stringify(this.analyticsDataModel.config.navWidgets));
		const overviewNavWidget = _.findWhere(navWidgets, { widgetPath: PATHS.OVERVIEW });
		if (overviewNavWidget && !this.overviewPrintableReport) {
			const index = _.indexOf(navWidgets, overviewNavWidget);
			navWidgets.splice(index, 1);
		}
		this.printableButtonItems = navWidgets;
		this.currentProduct = this.analyticsDataModel.getCurrentPath();
	}

	ngAfterViewInit(): void {
		this.isActive =
			_.where(this.printableButtonItems, { widgetPath: this.analyticsDataModel.getCurrentPath() }).length > 0;
	}
}
